import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';

import { APIURLConstantsService } from '../../services/api-url-service/apiurlconstants.service';
import { TokenStorageService } from './token-storage.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
 
@Injectable()export class AuthUserService implements CanActivate {
  private redirectUrl: string;
  public links = [];
  private options: {
            headers?: HttpHeaders,
            observe?: 'body',
            params?: HttpParams,
            reportProgress?: boolean,
            responseType: any,
            withCredentials?: boolean
        };
  public errorMessage: string = '';

  public get authHeader(): string {
    return `Bearer ${sessionStorage.getItem('access_token')}`;
  }

  public loggedIn() {
    return this.token.saveToken('token') !==  null;
  }
  esRegistrat(tipus: number){
    if(!this.token.getToken())return false;
    return true; //Qualsevol tipus de registre
  }

  login(email: string, password: string){

    this.options = {
      headers: new HttpHeaders().set('Authorization', this.authHeader),
      responseType: 'json',
    };
 
    return this.http.post<any>(APIURLConstantsService._API_BASE_URL + 'registre', {
      email: email,
      password: password
    }).subscribe(jwt => {
      try {
        this.token.saveToken(jwt.token);
        this.token.saveUser(jwt.user);
        this.router.navigate(['quefaig']);
      } catch (e) {
        this.errorMessage = "Usuari i/o contrasenya invàlids";
        return Promise.reject(e);
      }
    });

  }

  logout(){
    this.token.saveToken(null);
    this.token.saveUser(null);
 
    this.router.navigate(['login']);
  }

  canReport(){ return true;}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.token.getToken()) return true;

    // Store the attempted URL for redirecting
    this.redirectUrl = state.url;

    // Navigate to the login page
    this.router.navigate(['login']);
    return false;
  }

  constructor(private http: HttpClient, private router: Router, private token: TokenStorageService) {
    this.router = router;
    this.http = http;
  }

  ngOnInit() {
   this.links = [
    { target: '/dashboard', icon: 'home', 'description': 'Inici', permis:false },
    { target: '/dedicacions', icon: 'drag_indicator', 'description': 'Dedicacions', permis:false },
    { target: '/quefaig', icon: 'view_in_ar', 'description': 'Les meves tasques', permis:false },
    { target: '/oportunitats', icon: 'touch_app', 'description': 'Oportunitats', permis:false },
    { target: '/proposalpe', icon: 'view_list', 'description': 'Manifestacions d\'interès', permis:false },
    { target: '/proposals', icon: 'view_module', 'description': 'Propostes', permis:false },
    { target: '/projects', icon: 'view_week', 'description': 'Treballs', permis:false },
    { target: '/seguimenttecnic', icon: 'bookmarks', 'description': 'Seguiment Treballs', permis:false },
    { target: '/invoiceslist', icon: 'payment', 'description': 'Factures emeses', permis:false },
    { target: '/invoicesreblist', icon: 'redeem', 'description': 'Factures rebudes', permis:false },
    { target: '/utes', icon: 'zoom_in_map', 'description': 'UTE\'s', permis:false },
    { target: '/solvencies', icon: 'expand_circle_down', 'description': 'Solvències', permis:false },
    { target: '/clientssocislist', icon: 'people', 'description': 'Clients/Socis', permis:false },
    { target: '/contactes', icon: 'contacts', 'description': 'Contactes', permis:false },
    { target: '/documents', icon: 'library_books', 'description': 'Documents', permis:false },
    { target: '/users', icon: 'person', 'description': 'Usuaris', permis:false },
    { target: '/login', icon: 'login', 'description': 'Login', permis:false }
   ];
  }
  
}
